// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3NC3tj6gDesf7iwiBMYj4e:not(:last-child){margin-bottom:1.3rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statLine": "_3NC3tj6gDesf7iwiBMYj4e"
};
module.exports = ___CSS_LOADER_EXPORT___;
